import {Alert, Button, Col, Form, Row, Table} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import ApiService from "../../services/ApiService";

const AdminLevels = () => {

    const [levels, setLevels] = useState([]);
    const [newLevel, setNewLevel] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingValue, setEditingValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null); // { type: 'success' | 'danger', text }

    const loadLevels = () => {
        setLoading(true);
        ApiService.getLevelList()
            .then((obj) => setLevels(obj.levelCourseDtos || []))
            .catch(() => setMessage({type: "danger", text: "Errore nel caricamento dei livelli."}))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadLevels();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAdd = (e) => {
        e.preventDefault();
        const value = newLevel.trim();
        if (!value) return;
        ApiService.createLevel({level: value})
            .then(() => {
                setNewLevel("");
                setMessage({type: "success", text: `Livello "${value}" aggiunto.`});
                loadLevels();
            })
            .catch(() => setMessage({type: "danger", text: "Non è stato possibile aggiungere il livello. Riprova."}));
    };

    const startEdit = (lvl) => {
        setEditingId(lvl.id);
        setEditingValue(lvl.level);
        setMessage(null);
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditingValue("");
    };

    const saveEdit = (id) => {
        const value = editingValue.trim();
        if (!value) return;
        ApiService.editLevel({level: value}, id)
            .then(() => {
                cancelEdit();
                setMessage({type: "success", text: "Livello aggiornato."});
                loadLevels();
            })
            .catch(() => setMessage({type: "danger", text: "Non è stato possibile aggiornare il livello. Riprova."}));
    };

    const handleDelete = (lvl) => {
        if (!window.confirm(`Eliminare il livello "${lvl.level}"?`)) return;
        ApiService.deleteLevel(lvl.id)
            .then(() => {
                setMessage({type: "success", text: `Livello "${lvl.level}" eliminato.`});
                loadLevels();
            })
            .catch(() => setMessage({
                type: "danger",
                text: `Impossibile eliminare "${lvl.level}". Potrebbe essere ancora usato da uno o più corsi: riassegna prima quei corsi a un altro livello, poi riprova.`
            }));
    };

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col><Back/></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'title-page-section mt-5 mb-4'}>
                                <h2 className={'title'}>Livelli</h2>
                            </div>
                        </Col>
                    </Row>

                    {message &&
                        <Row className={'mb-3'}>
                            <Col xs={12} lg={8}>
                                <Alert variant={message.type} dismissible onClose={() => setMessage(null)}>
                                    {message.text}
                                </Alert>
                            </Col>
                        </Row>
                    }

                    <Row className={'mb-4'}>
                        <Col xs={12} lg={8}>
                            <Form onSubmit={handleAdd}>
                                <Form.Label className={'fw-bold'}>Aggiungi un nuovo livello</Form.Label>
                                <div className={'d-flex gap-2'}>
                                    <Form.Control
                                        type={'text'}
                                        placeholder={'Es. 3'}
                                        value={newLevel}
                                        onChange={(e) => setNewLevel(e.target.value)}
                                    />
                                    <Button type={'submit'} className={'btn btn-primary fw-bold px-4 text-nowrap'}
                                            disabled={!newLevel.trim()}>Aggiungi</Button>
                                </div>
                                <Form.Text className={'text-muted'}>
                                    I livelli sono condivisi da tutti i corsi. Nello shop vengono mostrati come
                                    "Livello &lt;nome&gt;".
                                </Form.Text>
                            </Form>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={8}>
                            {loading ?
                                <p>Caricamento…</p>
                                :
                                <Table hover responsive className={'align-middle'}>
                                    <thead>
                                    <tr>
                                        <th>Livello</th>
                                        <th className={'text-end'}>Azioni</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {levels.length === 0 &&
                                        <tr>
                                            <td colSpan={2} className={'text-muted'}>Nessun livello. Aggiungine uno
                                                qui sopra.
                                            </td>
                                        </tr>
                                    }
                                    {levels.map((lvl) => (
                                        <tr key={lvl.id}>
                                            <td>
                                                {editingId === lvl.id ?
                                                    <Form.Control
                                                        type={'text'}
                                                        value={editingValue}
                                                        autoFocus
                                                        onChange={(e) => setEditingValue(e.target.value)}
                                                    />
                                                    :
                                                    <span>Livello {lvl.level}</span>
                                                }
                                            </td>
                                            <td className={'text-end'}>
                                                <div className={'d-flex gap-2 justify-content-end'}>
                                                    {editingId === lvl.id ?
                                                        <>
                                                            <Button size={'sm'} className={'btn btn-sm btn-primary'}
                                                                    disabled={!editingValue.trim()}
                                                                    onClick={() => saveEdit(lvl.id)}>Salva</Button>
                                                            <Button size={'sm'} variant={'outline-secondary'}
                                                                    onClick={cancelEdit}>Annulla</Button>
                                                        </>
                                                        :
                                                        <>
                                                            <Button size={'sm'} variant={'outline-primary'}
                                                                    onClick={() => startEdit(lvl)}>Rinomina</Button>
                                                            <Button size={'sm'} variant={'outline-danger'}
                                                                    onClick={() => handleDelete(lvl)}>Elimina</Button>
                                                        </>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
}

export default AdminLevels;
